import { render, staticRenderFns } from "./UnitForm.vue?vue&type=template&id=f94c05ca&scoped=true&"
import script from "./UnitForm.vue?vue&type=script&lang=js&"
export * from "./UnitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94c05ca",
  null
  
)

export default component.exports